import {NullableNumber} from "../../../../../common/types/nullable-types";
import {computed} from "mobx";
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {ArenaGameFilterBase} from "./arena-game-filter-base";
import {GameInfo} from "../../../games/game-info";

export class DynamicArenaGameFilter extends ArenaGameFilterBase {

    @computed
    get games(): GameInfo[] {
        const currentArenaGames = this.services.arenas.getCurrentArena().allArenaGamesForFiltering;
        return  currentArenaGames.filter(gameInfo => this.filterDefinition.applyFilter(gameInfo) === ApplyGameFilterResult.IncludeGame)
    }

    get gamesCount(): NullableNumber {
        return this.games.length;
    }
}